export default __webpack_public_path__ + "static/media/venifyLogo.8b98cac7.png";